import React from 'react'
// import WorkWithUs from '../components/sections/WorkWithUs'
import BookRideSection from '../components/sections/BookRideSection'
import ContactForm from './form/ContactForm'

const PartnerWithUs = () => {
  return (
    <>
        <section className="workWith_wrap business_wrap section_pb section_pt">
        <div className="container">
            <div className="row g-4">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="work_left business_left">
                        <h2 className="wow fadeInLeft" data-wow-duration="1s">Grow Your Transport <br/> Business With ORBI
                        </h2>
                        <p className="wow fadeInLeft" data-wow-duration="2s">ORBI links trusted transport providers with
                            verified customers in the Tricity, helping you grow with steady demand, seamless support,
                            and confidence to scale.</p>
                        <img className="wow fadeInLeft" data-wow-duration="3s" src="assets/img/all-images/grow-img.png"
                            alt="Grow your transport business illustration"/>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="business_right wow fadeInRight">
                        <h2>Ready to Get Started? Let’s Talk</h2>
                        <ContactForm />

                        {/* <form id="contactForm">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-12">
                                    <div className="mb-2">
                                        <label for="" className="form-label">Full Name*</label>
                                        <input type="text" className="form-control" id="name" name="name"
                                            aria-describedby=""/>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-12">
                                    <div className="mb-2">
                                        <label for="" className="form-label">Email Address*</label>
                                        <input type="text" className="form-control" id="email" name="email"
                                            aria-describedby=""/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div className="mb-2">
                                        <label for="" className="form-label">Phone*</label>
                                        <input type="number" className="form-control" id="phone" name="phone"
                                            aria-describedby=""/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div className="mb-2">
                                        <label for="" className="form-label">Select Subject*</label>
                                        <select className="form-control" id="subject" name="subject">
                                            <option value="">Select</option>
                                            <option value="General">General</option>
                                            <option value="Ride">Ride</option>
                                            <option value="Partner">Partner</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="mb-2">
                                        <label for="" className="form-label">Message*</label>
                                        <textarea id="message" name="message" rows="5" className="form-control"></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-12">
                                    <button type="submit" id="submitBtn" className="btn">Submit</button>
                                </div>
                            </div>
                        </form> */}
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="solution_wrap section_mt">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="titles">
                        <h2 className="wow fadeInLeft">Solutions Built Around <br/> Your Business</h2>
                        <p className="wow fadeInRight d-md-block d-none">Every business has its strengths. ORBI connects you
                            with
                            opportunities across daily, corporate, and long-distance travel so you can grow where it
                            matters most.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-5 col-md-5 col-sm-12 col-12 d-md-block d-none">
                    <div className="solution_left wow fadeInLeft">
                        <img src="assets/img/all-images/built-around.jpg" alt="Business solutions illustration"/>
                    </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 col-12 d-md-block d-none">
                    <div className="solution_right wow fadeInRight">
                        <div className="solution_col">
                            <h3>Airport & Railway Transfers</h3>
                            <p>Timely pickups and drop-offs with fixed fares and zero surge, ideal for travellers who
                                rely on punctuality.</p>
                        </div>
                        <div className="solution_col solution_colYellow">
                            <h3>Daily Office Commute Rides</h3>
                            <p>Reliable, repeat bookings that bring stability to your business while supporting
                                companies and their teams.</p>
                        </div>
                        <div className="solution_col">
                            <h3>City Tours</h3>
                            <p>Tap into leisure travel with comfortable, organised rides for individuals and groups
                                exploring the city.</p>
                        </div>
                        <div className="solution_col">
                            <h3>Airport & Railway Transfers</h3>
                            <p>Timely pickups and drop-offs with fixed fares and zero surge, ideal for travellers who
                                rely on punctuality.</p>
                        </div>
                        <div className="solution_col solution_colYellow">
                            <h3>Daily Office Commute Rides</h3>
                            <p>Reliable, repeat bookings that bring stability to your business while supporting
                                companies and their teams.</p>
                        </div>
                        <div className="solution_col">
                            <h3>City Tours</h3>
                            <p>Tap into leisure travel with comfortable, organised rides for individuals and groups
                                exploring the city.</p>
                        </div>
                    </div>
                </div>

                <div className="col-12 d-md-none d-block">
                    <div className="faq_row">
                        <div className="accordion accordion-flush accordion-flushPlan wow fadeInUp"
                            id="accordionFlushExample1">
                            <div className="row g-4">
                                <div className="col-12">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="flush-headingOne1">
                                            <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne1"
                                                aria-expanded="false" aria-controls="flush-collapseOne1">
                                                Airport & Railway Transfers
                                            </button>
                                        </h2>
                                        <div id="flush-collapseOne1" className="accordion-collapse collapse"
                                            aria-labelledby="flush-headingOne1"
                                            data-bs-parent="#accordionFlushExample1">
                                            <div className="accordion-body">Timely pickup and drop-offs, with fixed fares
                                                and
                                                zero surge.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item accordion-item_yellow">
                                        <h2 className="accordion-header" id="flush-headingTwo2">
                                            <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo2"
                                                aria-expanded="false" aria-controls="flush-collapseTwo2">
                                                Daily Office Commute Rides
                                            </button>
                                        </h2>
                                        <div id="flush-collapseTwo2" className="accordion-collapse collapse"
                                            aria-labelledby="flush-headingTwo2"
                                            data-bs-parent="#accordionFlushExample1">
                                            <div className="accordion-body">Pre-schedule your daily rides, solo or shared,
                                                for a
                                                reliable work commute</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="flush-headingThree3">
                                            <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseThree3"
                                                aria-expanded="false" aria-controls="flush-collapseThree3">
                                                City Tours
                                            </button>
                                        </h2>
                                        <div id="flush-collapseThree3" className="accordion-collapse collapse"
                                            aria-labelledby="flush-headingThree3"
                                            data-bs-parent="#accordionFlushExample1">
                                            <div className="accordion-body">Comfortable rides with professional drivers to
                                                explore the city at your pace.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item accordion-item_yellow">
                                        <h2 className="accordion-header" id="flush-headingFour4">
                                            <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseFour4"
                                                aria-expanded="false" aria-controls="flush-collapseFour4">
                                                Outstation Trip
                                            </button>
                                        </h2>
                                        <div id="flush-collapseFour4" className="accordion-collapse collapse"
                                            aria-labelledby="flush-headingFour4"
                                            data-bs-parent="#accordionFlushExample1">
                                            <div className="accordion-body">Dependable transport for weekend getaways or
                                                business travel outside the city.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="flush-headingFive5">
                                            <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseFive5"
                                                aria-expanded="false" aria-controls="flush-collapseFive5">
                                                Corporate & Hotel Guest Transfers
                                            </button>
                                        </h2>
                                        <div id="flush-collapseFive5" className="accordion-collapse collapse"
                                            aria-labelledby="flush-headingFive5"
                                            data-bs-parent="#accordionFlushExample1">
                                            <div className="accordion-body">Seamless transfers designed for employees,
                                                clients,
                                                and hotel guests</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <section className="whyPartner_wrap section_mt section_pt section_pb d-md-block d-none">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="titles">
                        <h2 className="wow fadeInLeft">Why Partner with ORBI?</h2>
                        <p className="wow fadeInRight ">ORBI partnerships are designed for growth, built on trust, and
                            backed
                            by support. We work to create the conditions your business needs to thrive.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="partner_col wow fadeInLeft" data-wow-duration="2s">
                        <img src="assets/img/all-images/demand.jpg" alt="Consistent demand icon"/>
                        <h3>Consistent Demand</h3>
                        <p>Keep your vehicles moving with a steady flow of verified, pre-booked ride requests.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="partner_col wow fadeInLeft" data-wow-duration="1s">
                        <img src="assets/img/all-images/reliable-platform.jpg" alt="Reliable platform icon"/>
                        <h3>Reliable Platform</h3>
                        <p>Keep your vehicles moving with a steady flow of verified, pre-booked ride requests.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="partner_col wow fadeInRight" data-wow-duration="1s">
                        <img src="assets/img/all-images/smart-support.jpg" alt="Smart support icon"/>
                        <h3>Smart Support</h3>
                        <p>Real-time notifications, ride tracking, and 24/7 partner assistance that helps you manage
                            with ease.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="partner_col wow fadeInRight" data-wow-duration="2s">
                        <img src="assets/img/all-images/on-time-payouts.jpg" alt="On-time payouts icon"/>
                        <h3>On-Time Payouts</h3>
                        <p>Fast payments with complete visibility so you can plan, invest, and expand with confidence.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="whyPartner_wrap whyPartner_wrapMobile section_mt section_pb d-md-none d-block">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="titles titles_whyPartner mb-0">
                        <h2 className="wow fadeInLeft">Why Partner with ORBI?</h2>
                        <p className="wow fadeInRight ">ORBI partnerships are designed for growth, built on trust, and
                            backed
                            by support. We work to create the conditions your business needs to thrive.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-12 px-0">
                    <div className="faq_row faq_rowWhy_partner">
                        <div className="accordion accordion-flush accordion-flushWhy_partner wow fadeInUp"
                            id="accordionFlushExample_whyPartner">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="flush-headingOne11">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOne11" aria-expanded="false"
                                        aria-controls="flush-collapseOne11">
                                        Consistent Demand
                                    </button>
                                </h2>
                                <div id="flush-collapseOne11" className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne11"
                                    data-bs-parent="#accordionFlushExample_whyPartner">
                                    <div className="accordion-body">Keep your vehicles moving with a steady flow of
                                        verified,
                                        pre-booked ride requests.</div>
                                </div>
                            </div>
                            <div className="accordion-item accordion-item_yellow">
                                <h2 className="accordion-header" id="flush-headingTwo22">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwo22" aria-expanded="false"
                                        aria-controls="flush-collapseTwo22">
                                        Reliable Platform
                                    </button>
                                </h2>
                                <div id="flush-collapseTwo22" className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingTwo22"
                                    data-bs-parent="#accordionFlushExample_whyPartner">
                                    <div className="accordion-body">Keep your vehicles moving with a steady flow of
                                        verified,
                                        pre-booked ride requests.</div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="flush-headingThree33">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThree33" aria-expanded="false"
                                        aria-controls="flush-collapseThree33">
                                        Smart Support
                                    </button>
                                </h2>
                                <div id="flush-collapseThree33" className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingThree33"
                                    data-bs-parent="#accordionFlushExample_whyPartner">
                                    <div className="accordion-body">Real-time notifications, ride tracking, and 24/7 partner
                                        assistance that helps you manage with ease.</div>
                                </div>
                            </div>
                            <div className="accordion-item accordion-item_yellow">
                                <h2 className="accordion-header" id="flush-headingFour44">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFour44" aria-expanded="false"
                                        aria-controls="flush-collapseFour44">
                                        On-Time Payouts
                                    </button>
                                </h2>
                                <div id="flush-collapseFour44" className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingFour44"
                                    data-bs-parent="#accordionFlushExample_whyPartner">
                                    <div className="accordion-body">Fast payments with complete visibility so you can plan,
                                        invest, and expand with confidence.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


     {/* work with us section */}
    {/* <WorkWithUs /> */}

    {/* book ride section */}
    <BookRideSection />
    </>
  )
}

export default PartnerWithUs